module.exports = __webpack_public_path__ + "static/54-0b7acb25a764fddfe5b0d85ad4a3a6ee.png";